import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { GuildDiscoveryPage } from './GuildDiscoveryPage';
import { GuildCreatePage } from './GuildCreatePage';
import { GuildInviteAcceptPage } from './GuildInviteAcceptPage';
import { GuildDetailPage } from './GuildDetailPage';
import { GuildManagementPage } from './GuildManagementPage';

/**
 * Arche wrapper for Guilds — provides ArcheLayout with sidebar
 * and handles sub-routing for all guild pages.
 */
export function GuildArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<GuildDiscoveryPage />} />
        <Route path="/create" element={<GuildCreatePage />} />
        <Route path="/invite/:inviteCode" element={<GuildInviteAcceptPage />} />
        <Route path="/:guildId" element={<GuildDetailPage />} />
        <Route path="/:guildId/manage" element={<GuildManagementPage />} />
      </Routes>
    </ArcheLayout>
  );
}
